import { CobaltIconCalendarOutline } from '@cae/cobalt-react/icons/outline/CobaltIconCalendarOutline';
import { CobaltIconDatabaseOutline } from '@cae/cobalt-react/icons/outline/CobaltIconDatabaseOutline';
import { CobaltIconFolderOutline } from '@cae/cobalt-react/icons/outline/CobaltIconFolderOutline';
import { CobaltIconCalendarSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCalendarSolid';
import { CobaltIconDatabaseSolid } from '@cae/cobalt-react/icons/solid/CobaltIconDatabaseSolid';
import { CobaltIconFolderSolid } from '@cae/cobalt-react/icons/solid/CobaltIconFolderSolid';
import { APP_ROUTES } from '@routes/routes.constants';

import type { AppSideNavigationItem } from '../AppSideNavigation.types';

/**
 * Instruct module navigation items (Instructor)
 *
 * Permissions from roles_permissions.md:
 * - InstructorSchedule_View_Own: Controls visibility of Schedule group in nav
 * - AvailabilityManager_FullAccess_Own: Full access to Availability Manager; view calendar; submit/edit availability
 * - Resources_View_MyLocations: Access Resource Lookup page; view resource schedules for user's locations
 *
 * Note: Child paths use base paths (without dynamic segments) so prefix matching
 * in isActivePath correctly activates the parent group for any MFE sub-route.
 * Pattern: /instruct/[route]
 */
export const INSTRUCT_NAV: AppSideNavigationItem[] = [
  {
    label: 'Schedule',
    icon: CobaltIconCalendarOutline,
    path: `${APP_ROUTES.INSTRUCT_SCHEDULE_HOME}/*`,
    activeIcon: CobaltIconCalendarSolid,
    permission: [
      'InstructorSchedule_View_Own',
      'AvailabilityManager_FullAccess_Own',
    ],
    operator: 'some',
    children: [
      {
        label: 'My schedule',
        path: APP_ROUTES.INSTRUCT_MY_SCHEDULE,
        permission: 'InstructorSchedule_View_Own',
        featureFlag: 'instructormyschedule',
      },
      {
        label: 'Availability manager',
        path: APP_ROUTES.INSTRUCT_AVAILABILITY_MANAGER,
        permission: 'AvailabilityManager_FullAccess_Own',
        featureFlag: 'instructorExpAvailabilityManager',
      },
    ],
  },
  {
    label: 'Resource lookup',
    path: APP_ROUTES.RESOURCE_LOOKUP,
    icon: CobaltIconDatabaseOutline,
    activeIcon: CobaltIconDatabaseSolid,
    permission: 'Resources_View_MyLocations',
    featureFlag: 'instructorExpResourceLookup',
  },
  {
    label: 'Documents',
    icon: CobaltIconFolderOutline,
    activeIcon: CobaltIconFolderSolid,
    path: APP_ROUTES.INSTRUCT_DOCUMENTS,
    permission: [
      'CustomerTrainingDocuments_View_All',
      'CAETrainingDocuments_View_All',
    ],
    operator: 'some',
    children: [
      {
        label: 'Customer training documents (FAA)',
        path: APP_ROUTES.INSTRUCT_DOCUMENTS_COMPANIES,
        permission: 'CustomerTrainingDocuments_View_All',
      },
      {
        label: 'Customer training documents',
        path: APP_ROUTES.INSTRUCT_DOCUMENTS_CUSTOMER_DOCUMENTS,
        permission: 'CustomerTrainingDocuments_View_All',
        featureFlag: 'instructorViewCustomerNonFaaDocuments',
      },
      {
        label: 'CAE documents',
        path: APP_ROUTES.INSTRUCT_DOCUMENTS_CAE,
        permission: 'CAETrainingDocuments_View_All',
      },
    ],
  },
];
